import React from "react"
import { graphql } from "gatsby"
import { CoursesYamlEnrolment } from "../../types/graphql-types"
import { isNowOrInFuture, momentDependend, fmtDate } from "../util/text"

export const enrolmentQuery = graphql`
  fragment Enrolment on CoursesYamlEnrolment {
    time_limit
    email
    link {
      url
      text
    }
  }
`
interface Enrolment {
  enrolment: CoursesYamlEnrolment
  className?: string
}

export const Enrolment: React.FC<Enrolment> = ({
  enrolment,
  className = "",
}) => {
  const ist_war = momentDependend(enrolment.time_limit, "ist", "war")
  return (
    <div class={className}>
      <span>
        Für diese Lehrveranstaltung {ist_war} eine Anmeldung erforderlich. Die
        Anmeldefrist {ist_war} der {fmtDate(enrolment.time_limit)}.{" "}
      </span>
      {enrolment.email && isNowOrInFuture(enrolment.time_limit) ? (
        <span>
          Ihre Anmeldung senden Sie bitte per E-Mail an{" "}
          <span class="font-semibold">{enrolment.email}</span>.
        </span>
      ) : (
        ""
      )}
      {enrolment.link && isNowOrInFuture(enrolment.time_limit) ?  (
        <span>
          Bitte melden Sie sich über das{" "}
          <a class="text-fb12-blue-400 underline" href={enrolment.link.url}>
            {enrolment.link.text}
          </a>{" "}
          an.
        </span>
      ) : (
        ""
      )}
    </div>
  )
}
